<template lang="pug">
  section.loading-wrap(:style="{height: height + 'px'}")
    font-awesome-icon.loading(icon="spinner" spin far)
</template>
<script>
export default {
  props: {
    height: {
      type: Number,
      default: 400,
    },
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"
  .loading-wrap
    display flex
    align-items center
    justify-content center
    width 100%
    .loading
      font-size 4rem
      color $turquoise-color
</style>



// WEBPACK FOOTER //
// src/components/lei-components/Loading.vue